import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/eventClass/importer/eventClassImporterSelectors';
import EventClassService from 'src/modules/eventClass/eventClassService';
import fields from 'src/modules/eventClass/importer/eventClassImporterFields';
import { i18n } from 'src/i18n';

const eventClassImporterActions = importerActions(
  'EVENTCLASS_IMPORTER',
  selectors,
  EventClassService.import,
  fields,
  i18n('entities.eventClass.importer.fileName'),
);

export default eventClassImporterActions;